import { spawn } from 'redux-saga/effects';

import { sagas as addUserSagas } from './addUserModule';
import { sagas as removeUserSagas } from './removeUserModule';

export default function* vpnSagas() {
	yield spawn(addUserSagas);
	yield spawn(removeUserSagas);
}
